var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MemoIntro"},[_c('div',{staticClass:"images"},_vm._l((_vm.images),function(image){return _c('div',{key:image,staticClass:"Image"},[_c('MnemonicImage',{attrs:{"image":image,"focus":true}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }